import { Injectable, inject } from '@angular/core';
import { HdContentLanguageService } from './hd-content-language.service';

/** Output-pad van de via `angular.json` als asset gekopieerde channel-markdown. */
const HD_CHANNELS_ASSET_BASE = '/assets/docs/human-design/channels';

/** Talen waarvoor channel-markdown-assets bestaan; andere talen vallen terug op `nl`. */
const HD_CHANNELS_MARKDOWN_LANGS = new Set(['nl', 'en']);

/**
 * Kleine facade voor de markdown-assets van de BodyGraph-kanalen. Spiegelt
 * {@link HdStreamInfoService}: kanalen hebben geen varianten, enkel één `.md`
 * per canonieke channel-key.
 */
@Injectable({ providedIn: 'root' })
export class HdChannelInfoService {
  private readonly contentLang = inject(HdContentLanguageService);

  /**
   * URL naar het markdown-bestand voor een kanaal-key. Default-taal is de
   * content-taal (chart-override), met fallback op Nederlands.
   */
  channelMarkdownUrl(channelKey: string, lang?: string): string {
    const resolved = this.resolveMarkdownLang(lang ?? this.contentLang.effectiveLang());
    return `${HD_CHANNELS_ASSET_BASE}/${resolved}/${channelKey}.md`;
  }

  private resolveMarkdownLang(lang: string): string {
    const normalized = (lang || '').toLowerCase().split('-')[0];
    return HD_CHANNELS_MARKDOWN_LANGS.has(normalized) ? normalized : 'nl';
  }
}
